import { render } from "./ChatInput.vue?vue&type=template&id=b276e8f0&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=b276e8f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b276e8f0"]])

export default __exports__